import { Dropdown, NumberInput, Layer } from '@carbon/react';
import { useTcDcaForm } from './tc-dca-form-context';
import type {
  DiFormat,
  QiFormat,
  ForecastDurationOption,
} from 'types/api-payloads';
import styles from './tc-dca-configuration-panel.module.scss';

const QI_FORMAT_ITEMS: Array<{ id: QiFormat; label: string }> = [
  { id: 'months', label: 'Monthly' },
  { id: 'days', label: 'Daily' },
];

const DI_FORMAT_ITEMS: Array<{ id: DiFormat; label: string }> = [
  { id: 'effective', label: 'Effective' },
  { id: 'nominal', label: 'Nominal' },
];

const DURATION_OPTION_ITEMS: Array<{
  id: ForecastDurationOption;
  label: string;
}> = [
  { id: 'production_start', label: 'From production start' },
  { id: 'production_end', label: 'From production end' },
  { id: 'forecast_start', label: 'From forecast start' },
];

export const TcDcaForecastSettings = () => {
  const { form } = useTcDcaForm();

  return (
    <div className={styles.forecastSettingsWrapper}>
      <form.Field name="forecastDurationPeriod">
        {(field) => (
          <Layer>
            <NumberInput
              id="tc-dca-forecast-duration"
              label="Forecast Duration Years"
              min={1}
              max={100}
              step={1}
              hideSteppers
              value={field.state.value ?? ''}
              placeholder="30"
              allowEmpty
              inputMode="numeric"
              size="md"
              invalid={
                field.state.meta.isTouched && !!field.state.meta.errors?.length
              }
              invalidText={field.state.meta.errors?.[0] ?? ''}
              onChange={(
                _e: unknown,
                { value }: { value: string | number }
              ) => {
                field.handleChange(value === '' ? 0 : Number(value));
              }}
              onBlur={field.handleBlur}
            />
          </Layer>
        )}
      </form.Field>

      <form.Field name="forecastDurationOption">
        {(field) => (
          <Layer>
            <Dropdown
              id="tc-dca-forecast-duration-option"
              titleText="Forecast Duration Options"
              label="Forecast Duration Options"
              items={DURATION_OPTION_ITEMS}
              itemToString={(item) => item?.label ?? ''}
              selectedItem={
                DURATION_OPTION_ITEMS.find((o) => o.id === field.state.value) ??
                null
              }
              onChange={({ selectedItem }) => {
                if (selectedItem) field.handleChange(selectedItem.id);
              }}
            />
          </Layer>
        )}
      </form.Field>

      <div className={styles.forecastFormatsRow}>
        <form.Field name="qiFormat">
          {(field) => (
            <div className={styles.forecastFormatControl}>
              <Layer>
                <Dropdown
                  id="tc-dca-qi-format"
                  titleText="qi format"
                  label={
                    QI_FORMAT_ITEMS.find((i) => i.id === field.state.value)
                      ?.label ?? 'qi format'
                  }
                  items={QI_FORMAT_ITEMS}
                  itemToString={(item) => item?.label ?? ''}
                  selectedItem={
                    QI_FORMAT_ITEMS.find((i) => i.id === field.state.value) ??
                    null
                  }
                  onChange={({ selectedItem }) => {
                    if (selectedItem) field.handleChange(selectedItem.id);
                  }}
                />
              </Layer>
            </div>
          )}
        </form.Field>

        <form.Field name="diFormat">
          {(field) => (
            <div className={styles.forecastFormatControl}>
              <Layer>
                <Dropdown
                  id="tc-dca-di-format"
                  titleText="Di format"
                  label={
                    DI_FORMAT_ITEMS.find((i) => i.id === field.state.value)
                      ?.label ?? 'Di format'
                  }
                  items={DI_FORMAT_ITEMS}
                  itemToString={(item) => item?.label ?? ''}
                  selectedItem={
                    DI_FORMAT_ITEMS.find((i) => i.id === field.state.value) ??
                    null
                  }
                  onChange={({ selectedItem }) => {
                    if (selectedItem) field.handleChange(selectedItem.id);
                  }}
                />
              </Layer>
            </div>
          )}
        </form.Field>
      </div>
    </div>
  );
};
